import useAuthentication from "@hooks/useAuthentication"
import Indexv1 from "./v1"
import Indexv2 from "./v2"

const Cashier = () => {
    const {user} = useAuthentication()
    return user?.paymentmethod === "normal" ? <Indexv1 /> : <Indexv2 />
}

export default Cashier   